import {store} from '../stores'

/**
 * This function will check the status of the user that if it's not login by synchronized the data
 * from store.
 */
export const canEnterModule = (to, from, next, moduleName) => {

  const needPageGroup = store.state.account.defaultPageGroups.find(x => x.active && x.route === moduleName)
  if(!needPageGroup) {
    return
  }

  if(store.state.account.user && store.state.account.user.is_primary_login_account) {
    return next()
  } else if (store.getters['account/pageAccess'].includes(moduleName)) {
    return next()
  } else {
    const currentUserGroup = store.state.account.user.user_group || {}
    const query = {
      page_en: needPageGroup.name_en,
      page_jp: needPageGroup.name_jp,
      group_en: currentUserGroup.name_en,
      group_jp: currentUserGroup.name_jp,
    }

    return next({
      name: 'Page403', query
    })
  }
}

